// export const devlogAPIURL = "https://devlogapi.herokuapp.com";
export const devlogAPIURL = "https://devlog-svc.onrender.com";
// export const devlogAPIURL = "http://localhost:8080";
// export const devlogAPIURL = "https://nodeapi-o0h5.onrender.com";

